import {markRaw} from "vue";
import {Toaster} from "@datapas/vue-feedback";

const toaster = new Toaster;

export class ToasterPluginVue {
	static install(app) {
		app.config.globalProperties.$toaster = toaster;
	}
}

export function ToasterPluginPinia() {
	return {
		$toaster: markRaw(toaster),
	}
}